import { type ReactNode } from "react";
import { Stack, styled, type StackProps } from "~/common/mui";
import { SearchInputGroupTextField } from "./SearchInputGroupTextField";
import { SearchInputGroupSelect } from "./SearchInputGroupSelect";
import { SearchInputGroupDivider } from "./SearchInputGroupDivider";
import { SearchInputGroupIconButton } from "./SearchInputGroupIconButton";
import { SearchInputGroupText } from "./SearchInputGroupText";
import { SearchInputGroupAutocomplete } from "./SearchInputGroupAutocomplete";

export interface SearchInputGroupProps extends Omit<StackProps, "direction"> {
  children?: ReactNode;
}

const StyledStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.surfaceContainer.high,
  borderRadius: "28px",
  height: "56px",
  paddingLeft: "12px",
  paddingRight: "8px",
  alignItems: "center",
}));

export const SearchInputGroup = ({ children, ...props }: SearchInputGroupProps) => {
  return (
    <StyledStack direction="row" gap={0.5} {...props}>
      {children}
    </StyledStack>
  );
};

SearchInputGroup.TextField = SearchInputGroupTextField;
SearchInputGroup.Select = SearchInputGroupSelect;
SearchInputGroup.Divider = SearchInputGroupDivider;
SearchInputGroup.IconButton = SearchInputGroupIconButton;
SearchInputGroup.Text = SearchInputGroupText;
SearchInputGroup.Autocomplete = SearchInputGroupAutocomplete;
